import {Injectable} from '@angular/core';
import {Response, URLSearchParams, RequestOptions} from '@angular/http';
import {HttpAuth} from './http-auth.service';
import {environment} from '../../environments/environment';
import {Observable} from 'rxjs';
import {JobsOffer, PaginatedJobs} from '../models/jobs-offer';
import {Profile, PaginatedProfile} from '../models/profile';
import 'rxjs/add/operator/map';
import { ApplicantFilter } from '../interfaces/filters';

@Injectable()
export class CandidateService {

  private url: string = `${ environment.apiRoot }/applicant/`;
  private urlContract: string = `${ environment.apiRoot }/applicant-contract/`;
  private urlProfile: string = `${ environment.apiRoot }/profile/`;
  constructor(private http: HttpAuth) { }

  public getCandidates(filters: ApplicantFilter, requirement: boolean, page: number, pagecount?:number, jobId?: string): Observable<PaginatedJobs> {
    let params: URLSearchParams = new URLSearchParams();

    params.append('page', String(page));

    if(pagecount != null) {
      params.append('pagecount', String(pagecount));
    } else {
      params.append('pagecount', '10');
    }

    if(filters.jobId != null) {
      params.append('id', filters.jobId);
    }

    if(filters.query != null) {
      params.append('query', filters.query);
    }

    if(filters.query_edu != null) {
      params.append('query_edu', filters.query_edu);
    }
    if(filters.query_exp != null) {
      params.append('query_exp', filters.query_exp);
    }
    if(filters.query_skill != null) {
      params.append('query_skill', filters.query_skill);
    }
    if(filters.query_sex != null) {
      params.append('query_sex', filters.query_sex);
    }
    if(filters.query_edulvl != null) {
      params.append('query_edulvl', filters.query_edulvl);
    }
    if(filters.query_language != null) {
      params.append('query_language', filters.query_language);
    }
    if(filters.query_course != null) {
      params.append('query_course', filters.query_course);
    }
    if(filters.query_description != null) {
      params.append('query_description', filters.query_description);
    }
    if(filters.query_radius != null) {
      params.append('query_radius', String(filters.query_radius));
    }
    if(filters.query_latitude != null) {
      params.append('query_latitude', String(filters.query_latitude));
    }
    if(filters.query_longitude != null) {
      params.append('query_longitude', String(filters.query_longitude));
    }

    if(jobId != null) {
      params.append('job_id', jobId);
    }

    params.append('favorite', String(filters.filters.favorite));

    // WHAT THE FUCK

    if (filters.filters.custom) {
      filters.filters.custom.forEach(element => {
        params.append('status[]', element);
      });

    }
    if (filters.filters.rejected) {
      params.append('status[]', '-1');
    }
    if (filters.filters.read) {
      params.append('status[]', '100');
    }
    if (filters.filters.unread) {
      params.append('status[]', '0');
    }
    if (filters.filters.selected) {
      params.append('status[]', '275');
    }
    if (filters.filters.hired) {
      params.append('status[]', '300');
    }

    params.append('summary', '1');

    params.append('mandatoryrequirementsmet', requirement ? '1' : '0');

    return this.http.get(this.url, {search: params})
      .map(this.extractData)
      .catch(this.handleError);
  }

  public getProfiles(location: boolean, filters: ApplicantFilter, page: number, pagecount?:number): Observable<PaginatedProfile> {
    let params: URLSearchParams = new URLSearchParams();

    params.append('page', String(page));

    if(pagecount != null) {
      params.append('pagecount', String(pagecount));
    } else {
      params.append('pagecount', '10');
    }

    if(filters.jobId != null) {
      params.append('id', filters.jobId);
    }

    if(filters.query != null) {
      params.append('query', filters.query);
    }

    if(filters.query_edu != null) {
      params.append('query_edu', filters.query_edu);
    }
    if(filters.query_exp != null) {
      params.append('query_exp', filters.query_exp);
    }
    if(filters.query_skill != null) {
      params.append('query_skill', filters.query_skill);
    }
    if(filters.query_sex != null) {
      params.append('query_sex', filters.query_sex);
    }
    if(filters.query_edulvl != null) {
      params.append('query_edulvl', filters.query_edulvl);
    }
    if(filters.query_language != null) {
      params.append('query_language', filters.query_language);
    }
    if(filters.query_course != null) {
      params.append('query_course', filters.query_course);
    }
    if(filters.query_description != null) {
      params.append('query_description', filters.query_description);
    }
    if (location) {
      if(filters.query_radius != null) {
        params.append('query_radius', String(filters.query_radius));
      }
      if(filters.query_latitude != null) {
        params.append('query_latitude', String(filters.query_latitude));
      }
      if(filters.query_longitude != null) {
        params.append('query_longitude', String(filters.query_longitude));
      }
    }

    if(filters.query_country != null) {
        params.append('query_country', String(filters.query_country));
      }
      if(filters.query_countryadmin1 != null) {
        params.append('query_admin1', String(filters.query_countryadmin1));
      }
      if(filters.query_countryadmin2 != null) {
        params.append('query_admin2', String(filters.query_countryadmin2));
      }

    params.append('favorite', String(filters.filters.favorite));

    // WHAT THE FUCK
    if (filters.filters.custom) {
      filters.filters.custom.forEach(element => {
        params.append('status[]', element);
      });
    }
    if (filters.filters.rejected) {
      params.append('status[]', '-1');
    }
    if (filters.filters.read) {
      params.append('status[]', '100');
    }
    if (filters.filters.unread) {
      params.append('status[]', '0');
    }
    if (filters.filters.selected) {
      params.append('status[]', '275');
    }
    if (filters.filters.hired) {
      params.append('status[]', '300');
    }

    return this.http.get(this.urlProfile, {search: params})
      .map(this.extractData)
      .catch(this.handleError);
  }

  public getCandidatesStatus(status: any, page: number, pagecount?: number, jobId?: string, required?: boolean): Observable<PaginatedJobs>
  {

    const params: URLSearchParams = new URLSearchParams();

    params.append('page', String(page));
    if (required != null || required != undefined) {
      if (required) {
        params.append('mandatoryrequirementsmet', String(1));
      } else {
        params.append('mandatoryrequirementsmet', String(0));
      }
    }

    if (pagecount != null) {
      params.append('pagecount', String(pagecount));
    } else {
      params.append('pagecount', '10');
    }

    if (jobId != null) {
      params.append('id', jobId);
    }

    // WHAT THE FUCK
    if (status.applied) {
      params.append('status[]', '0');
    }
    if (status.rejected) {
      params.append('status[]', '-1');
    }
    if (status.read) {
      params.append('status[]', '100');
    }
    if (status.unread) {
      params.append('status[]', '0');
    }
    if (status.selected) {
      params.append('status[]', '275');
    }
    if (status.hired) {
      params.append('status[]', '300');
    }
    if (status.configurable) {
      params.append('status[]', status.item_conf);
    }

    return this.http.get(this.url, {search: params})
      .map(this.extractData)
      .catch(this.handleError);
  }

  public getCandidatesContract(status: any, page: number, pagecount?: number, jobId?: string, required?: boolean): Observable<PaginatedJobs>
  {

    const params: URLSearchParams = new URLSearchParams();

    params.append('page', String(page));
    if (required != null || required != undefined) {
      if (required) {
        params.append('mandatoryrequirementsmet', String(1));
      } else {
        params.append('mandatoryrequirementsmet', String(0));
      }
    }

    if (pagecount != null) {
      params.append('pagecount', String(pagecount));
    } else {
      params.append('pagecount', '10');
    }

    if (jobId != null) {
      params.append('id', jobId);
    }

    // WHAT THE FUCK
    if (status.applied) {
      params.append('status[]', '0');
    }
    if (status.rejected) {
      params.append('status[]', '-1');
    }
    if (status.read) {
      params.append('status[]', '100');
    }
    if (status.unread) {
      params.append('status[]', '0');
    }
    if (status.selected) {
      params.append('status[]', '275');
    }
    if (status.hired) {
      params.append('status[]', '300');
    }
    if (status.rehired) {
      params.append('status[]', '375');
    }
    if (status.configurable) {
      params.append('status[]', status.item_conf);
    }

    return this.http.get(this.urlContract, {search: params})
      .map(this.extractData)
      .catch(this.handleError);
  }

  //noinspection JSMethodCanBeStatic
  private extractData(res: Response) {
    let body = res.json();

    return body.data || {};
  }

  //noinspection JSMethodCanBeStatic
  //noinspection JSMethodCanBeStatic
  private handleError(error: Response | any) {
    let errMsg: string;

    if (error instanceof Response) {
      const body = error.json() || '';
      const err = body.meta && body.meta.message || JSON.stringify(body);
      errMsg = `${err}`;
    } else {
      errMsg = error.message ? error.message : error.toString();
    }

    console.error(errMsg);

    return Observable.throw(errMsg);
  }
}



// WEBPACK FOOTER //
// /var/www/_deploy/front-company-testing/2018-09-30-21-57-10/src/app/services/candidate.service.ts